module.exports = __webpack_public_path__ + "img/fw_workflow_1.a0dde2d8.png";